import React from 'react'
import { Button } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import BlockIcon from '@mui/icons-material/Block'
import { getGrooverText } from '../libs/GrooverTextRepository'
import { ActivityRegistrationStatus } from '../../../pure-js/types/GrooverTypes'

interface Props {
  registrationStatus: ActivityRegistrationStatus
}

const RegistrationStatusButton: React.FC<Props> = ({ registrationStatus }) => {
  let icon: React.ReactElement = <LockOutlinedIcon />
  let color = '#d32f2f'
  let bg = '#ffebee'
  let textKey = 'adminGeneralEnumsEnrollmentStatusEnrollmentStatusClosed'

  if (registrationStatus === ActivityRegistrationStatus.Closed) {
    icon = <LockOutlinedIcon />
    textKey = 'adminGeneralEnumsEnrollmentStatusEnrollmentStatusClosed'
  } else if (registrationStatus === ActivityRegistrationStatus.Full) {
    icon = <BlockIcon />
    textKey = 'adminGeneralEnumsEnrollmentStatusEnrollmentStatusFull'
  } else if (registrationStatus === ActivityRegistrationStatus.Special) {
    icon = <BlockIcon />
    color = '#578fff'
    bg = '#e5f5ff'
    textKey = 'adminGeneralEnumsEnrollmentStatusEnrollmentStatusSpecial'
  }

  return (
    <Button
      variant="contained"
      disabled
      fullWidth
      startIcon={icon}
      sx={{
        backgroundColor: bg,
        color: color,
        border: `1px solid ${color}`,
        fontWeight: 'bold',
        letterSpacing: 1,
        boxShadow: 'none',
        '& .MuiButton-startIcon': { color: color },
        '&:hover': {
          backgroundColor: bg,
          color: color,
          border: `1px solid ${color}`,
          boxShadow: 'none'
        },
        '&.Mui-disabled': {
          backgroundColor: bg,
          color: color,
          border: `1px solid ${color}`,
          opacity: 1
        }
      }}
    >
      {getGrooverText(textKey)}
    </Button>
  )
}

export default RegistrationStatusButton
